export * from "./lib/components/JotaiProvider";
export * from "./lib/hooks/useAuth";
export * from "./lib/hooks/useAwsSso";
export * from "./lib/hooks/useAuthorsForDeepLink";
export * from "./lib/hooks/useAuthRedirect";
export * from "./lib/hooks/useAutoUpdater";
export * from "./lib/hooks/useWorkflows";
export * from "./lib/hooks/useWorkflowsLoader";
export * from "./lib/hooks/useCanvasRuntime";
export * from "./lib/hooks/useCloneDocument";
export * from "./lib/hooks/useIsCloning";
export * from "./lib/hooks/useCommitGraph";
export * from "./lib/hooks/useCompiledCells";
export * from "./lib/hooks/useCreateDocument";
export * from "./lib/hooks/useCreatePage";
export * from "./lib/hooks/useDailyNotes";
export * from "./lib/hooks/useDeleteDocument";
export * from "./lib/hooks/useDuplicateDocument";
export * from "./lib/hooks/useDraftCommitMessage";
export * from "./lib/hooks/useDocumentAuth";
export * from "./lib/hooks/useDocumentCollabEnabled";
export * from "./lib/hooks/useDocumentCollabInfo";
export * from "./lib/hooks/useDocumentFromCurrentRoute";
export * from "./lib/hooks/useDocumentHasConflicts";
export * from "./lib/hooks/useDocumentHasLocal";
export * from "./lib/hooks/useDocumentLoader";
export * from "./lib/hooks/useDocumentLocalPath";
export * from "./lib/hooks/useDocumentMetadata";
export * from "./lib/hooks/useDocumentPermissions";
export * from "./lib/hooks/useEditorState";
export * from "./lib/hooks/useEditorStateForCurrRoute";
export * from "./lib/hooks/useEnv";
export * from "./lib/hooks/useEnvironments";
export * from "./lib/hooks/useFeatureFlags";
export * from "./lib/hooks/useGitBranchAheadBehind";
export * from "./lib/hooks/useGitBranches";
export * from "./lib/hooks/useGitConfig";
export * from "./lib/hooks/useGitDiff";
export * from "./lib/hooks/useGitDiffOrShow";
export * from "./lib/hooks/useGitDiffRefs";
export * from "./lib/hooks/useGitHistory";
export * from "./lib/hooks/useGitOperations";
export * from "./lib/hooks/useGitRemotes";
export * from "./lib/hooks/useGitShow";
export * from "./lib/hooks/useGitStatus";
export * from "./lib/hooks/useRequestExecution";
export * from "./lib/hooks/useHttpRequestPage";
export * from "./lib/hooks/useRequestPageStatus";
export * from "./lib/hooks/useHttpRequestPageForCurrRoute";
export * from "./lib/hooks/useRequestPageHistory";
export * from "./lib/hooks/useRequestPageHistoryForCurrRoute";
export * from "./lib/hooks/useImportMarkdownRepo";
export * from "./lib/hooks/useInternet";
export * from "./lib/hooks/useRecentUpdates";
export * from "./lib/hooks/useKubeContexts";
export * from "./lib/hooks/useLocation";
export * from "./lib/hooks/useNavigationHistory";
export * from "./lib/hooks/useMetadataKeyForCurrRoute";
export * from "./lib/hooks/usePageEditorState";
export * from "./lib/hooks/usePageFromCurrentRoute";
export * from "./lib/hooks/usePathDocumentDir";
export * from "./lib/hooks/usePathDocumentsDir";
export * from "./lib/hooks/usePathPageDir";
export * from "./lib/hooks/usePathPageFile";
export * from "./lib/hooks/usePathPageRelatedFile";
export * from "./lib/hooks/usePathPageRelatedFilesDir";
export * from "./lib/hooks/usePresence";
export * from "./lib/hooks/useRedeemInvite";
export * from "./lib/hooks/useRelatedFileContents";
export * from "./lib/hooks/useRemoteRepoExists";
export * from "./lib/hooks/useRouteParams";
export * from "./lib/hooks/useSearchUsers";
export * from "./lib/hooks/useShareTabData";
export * from "./lib/hooks/useSyncSnapshot";
export * from "./lib/hooks/useTauriEventListener";
export * from "./lib/hooks/useTerminal";
export * from "./lib/hooks/useTemplates";
export * from "./lib/hooks/useTemplatePreviewImage";
export * from "./lib/hooks/useImportTemplatePages";
export * from "./lib/hooks/useIsTemplate";
export * from "./lib/hooks/useTemplateConfig";
export * from "./lib/hooks/useTemplatePreviewUpload";
export * from "./lib/hooks/useTldrawSnapshot";
export * from "./lib/hooks/useAgentInstructionEditorState";
export * from "./lib/hooks/useAgentInstructionFiles";
export * from "./lib/hooks/useAgentsMdSuggestion";
export * from "./lib/hooks/useHasManagedSection";
export * from "./lib/hooks/useDocumentOnboarding";
export * from "./lib/hooks/useTemplateOnboarding";
export * from "./lib/hooks/useUserById";
export * from "./lib/hooks/useVersioningDialog";
export * from "./lib/hooks/useWorkspaceAccountStatus";
export * from "./lib/hooks/useWorkspaceCheckout";
export * from "./lib/hooks/useWorkspaceFromCurrentRoute";
export * from "./lib/hooks/useWorkspaceAvatar";
export * from "./lib/hooks/useWorkspaceMemberships";
export * from "./lib/hooks/useWorkspaces";
export * from "./lib/hooks/useAttachments";

// Export commonly used atoms for advanced use cases

export {
	$addTemplateDocument,
	$document,
	$documentsList,
	$filteredDocuments,
	$refreshRemoteDocuments,
	$removeTemplateDocument,
} from "./internal/document-list";
export type { DocsListItem, DocsListRemoteEntry } from "./internal/document-list";
export { isViewerPermission } from "./internal/document-list";
export { isAgentInstructionPage, PRIMARY_AGENT_INSTRUCTION_FILE } from "./internal/document";
export {
	$dailyNotesDocument,
	$ensureDailyNotesDocumentEffect,
	DAILY_NOTES_DOCUMENT_TYPE,
} from "./internal/daily-notes";
export {
	$ensureDatePage,
	$ensureTodayPage,
	compareDailyNotesPages,
	getTodaySlugPath,
	parseDateSlug,
} from "./internal/daily-notes/today-page.atom";
export { $accessTokenFunc, $isAuthenticated } from "./internal/authenication";
export {
	$workflowSchedulerEffect,
	$workflowSchedule,
	AGENT_LABELS,
	workflowFormSchema,
} from "./internal/workflows";
export { $simulateOffline } from "./internal/utils/internet.atom";
export type {
	Workflow,
	WorkflowAgent,
	WorkflowRun,
	WorkflowScheduleEntry,
} from "./internal/workflows";
export { metadataKeyForDocsRoute } from "./internal/document-metadata/documentMetadataKey";
export { $purgeDocument } from "./internal/document-loader";
export { $documentMetadataFromRemote } from "./internal/document-metadata/document-metadata.atom";
export {
	$documentMetadata,
	$documentMetadataError,
	$loadDocumentMetadata,
	$unloadDocumentMetadata,
} from "./internal/document-metadata/metadata-state.atom";
export {
	$editorState,
	$editorStateError,
	$loadEditorState,
	$unloadEditorState,
} from "./internal/prosemirror/editor-state.atom";
export { editorStateKeyForDocsRoute } from "./internal/prosemirror/editorStateKey";
export { $pluginFactory } from "./internal/prosemirror/plugins-factory.atom";
export { registerPageEditorPluginsFactory } from "./internal/page";
export {
	$pageMetadataBySlugPath,
	buildDefaultPagePath,
	buildFullSlugPath,
	findPageBySlugPath,
} from "./internal/page-metadata/page-metadata.atom";
export {
	registerPluginFactory,
	type PluginFactory,
	type PluginFactoryOptions,
} from "./internal/prosemirror";

export { $upsertWorkspace, isPersonalWorkspace } from "./internal/workspaces";
export type { RecentUpdate } from "./internal/recent-updates";

// Templates
export {
	$templates,
	$loadTemplateMetadata,
	$loadTemplateEditorState,
	$importTemplatePages,
	$isTemplate,
	$templateConfig,
	$saveTemplateConfig,
	$localTemplatePreviewImage,
	$uploadTemplatePreview,
} from "./internal/templates";
export type { Template, TemplateWorkspace } from "./internal/templates";

// Document ID Context (for overriding route params in template previews etc.)
export { DocumentIdProvider, useDocumentIdOverride } from "./lib/hooks/DocumentIdContext";

// Page link utilities for title-based links
export {
	buildPageLinkText,
	getPageReferenceFragmentCandidates,
	parseLinkText,
	resolvePageFromLinkText,
	resolvePageReference,
	resolvePageHref,
	resolvePageHrefsInHtml,
	splitOnUnescapedSlash,
	unescapePageLinkTitle,
} from "./internal/page-link";

// Cell compiler registration
export { registerCellCompiler, type CellCompilerFn } from "./internal/runtime";

// Canvas runtime registration
export {
	registerCanvasRuntimeFactory,
	type CanvasRuntimeFactory,
	type CanvasRuntimeParams,
	type Disposable,
	type MutationBuilder,
} from "./internal/canvas-runtime";

// Query types and atoms (TanStack Query-inspired API)
export type {
	EnvFetchResponse,
	QueryError,
	QueryErrorCode,
	QueryFetchStatus,
	QueryHealth,
	QueryResult,
	QueryStatus,
	QueryBuilder,
	QueryBuilderOptions,
	QueryHandle,
	RequestPageHistoryEntry,
	RequestPageHistoryState,
} from "./internal/request-page";

// Mutation types and atoms (TanStack Query useMutation-inspired API)
export type { MutationBuilderOptions, MutationHandle } from "./internal/request-page";

export {
	$queryExecutor,
	$queryExecutorCore,
	$queryState,
	$queryStateKeys,
	$queryCleanup,
	$mutationExecutor,
	$loadHttpRequestPage,
	$unloadHttpRequestPage,
	requestPageKeyForDocsRoute,
	createEmptyQueryState,
	createQueryBuilder,
	createQueryHandle,
	createMutationBuilder,
	createMutationHandle,
	substituteVariables,
	findUnresolvedVariables,
	ensureAwsFetchInterceptor,
	ensureGeneralFetchInterceptor,
	invokeExecuteEnvFetch,
	isTauriIpcUrl,
	resolveSecretsproxyContext,
	setCurrentFetchContext,
	shouldBypassProxy,
} from "./internal/request-page";

export { useQueryBuilder } from "./lib/hooks/useQueryBuilder";
export { useMutationBuilder } from "./lib/hooks/useMutationBuilder";

// Export types
export * from "./internal/docsapi/docsapi.atom";
export * from "./internal/document/sharing/permissions.types";
export * from "./internal/document/sharing/users.types";
export type { PlanStatus, SyncAction } from "./internal/document/sync/sync.types";
export {
	$documentRequiredVars,
	$documentEnvVarReferences,
	$documentEnvVarHints,
	$documentMissingSecrets,
	scanDocumentsReferencingSecret,
	type DocumentRequiredVarsStatus,
	type DocumentRequiredVarsEnvironmentStatus,
	type DocumentSecretReference,
} from "./internal/document/required-vars.atom";
export type { EnvVarHint } from "./internal/request-page";
export {
	$documentOnboardingState,
	$onboardingDismissed,
	type DocumentOnboardingState,
} from "./internal/document/onboarding.atom";
export {
	$templateOnboarding,
	$setTemplateOnboarding,
	$completeTemplateOnboarding,
} from "./internal/document/template-onboarding.atom";
export type { TemplateOnboardingConfig } from "./internal/document/template-onboarding.types";
export type {
	BranchInfo,
	GitAheadBehind,
	GitAheadBehindCommit,
	GitBranchAheadBehindInput,
	GitBranchAnalyzeInput,
	GitBranchDeleteInput,
	GitBranchNewInput,
	GitBranchSwitchInput,
	GitBranchTrackInput,
	GitCommitInput,
	GitDiff,
	GitFetchInput,
	GitMergeAnalysis,
	GitPushInput,
	GitRemote,
	GitRemoteAddInput,
	GitRepoHistory,
	GitRepoStatus,
	GitShow,
	GitStashPopInput,
	GitStashSaveInput,
} from "./internal/git";
export type { Workspace } from "./internal/workspaces";
export type { UserWithMembership } from "./internal/docsapi/docsapi.types";

// Attachments
export {
	$attachmentsList,
	$removeAttachment,
	$addAttachmentFromPath,
	$addAttachmentFromBytes,
	$csvBindings,
	QUERYABLE_EXTENSIONS,
	isQueryableFile,
} from "./internal/attachments";
export type { AttachmentInfo, CsvTableBinding } from "./internal/attachments";

// Document Store V2
export { $documentStoreV2 } from "./internal/reboot";

// in order to use the image plugin, we need to export the filesystem and path api without react.
export {
	exists,
	mkdir,
	readBinaryFile,
	readDir,
	readTextFile,
	writeBinaryFile,
	writeTextFile,
} from "./internal/filesystem/filesystem.internal";
export {
	getAttachmentsDirPath,
	getBaseDir,
	getDocumentDirPath,
	getDocumentDotMomentPath,
	getDocumentsDirPath,
	getMomentDbPath,
	getMomentDirPath,
	getPageDirPath,
	getPageFilePath,
	getPageRelatedFilePath,
	getPageRelatedFilesDirPath,
} from "./internal/paths/paths.internal";

// exporting env, as i would like to use this instead of
// duplicating the code in moment/ui and auth/common
export { env, getPublishWebUrl, initAppVersion } from "./internal/env";
export type { Mode } from "./internal/env";

// Export Jotai store for direct access (e.g., from AuthProvider)
export { store } from "./internal/store";

// Export temporary token handling for password-protected documents
export { $documentToken, getValidDocumentToken } from "./internal/document-auth";
export type { DocumentToken, GetValidTokenResult } from "./internal/document-auth";
// Export File Watcher
export { $fileChanges } from "./internal/file-watcher";
export type { FileChangedPayload } from "./internal/file-watcher";

// Export AWS
export {
	$awsSsoStatus,
	$selectedAwsProfile,
	$selectedAwsRegion,
	$awsLoginDialogOpen,
	$awsLoginRequiredError,
} from "./internal/aws";
export { awsApi, $awsProfiles } from "./internal/_interop/aws";
export type {
	AwsAPI,
	AwsHttpRequest,
	AwsHttpResponse,
	AwsProfile,
	AwsProfileStatus,
	AwsSsoLoginRequest,
	AwsSsoStatus,
} from "./internal/_interop/aws";

// Export Environments
export {
	$environmentNames,
	$environmentVars,
	$selectedEnvironmentName,
	$selectedEnvironmentVars,
	$resolvedDocumentEnvironmentVars,
	$documentEnvironmentText,
	$documentEnvironmentRawVars,
	$writeDocumentEnvironmentText,
	$deleteDocumentEnvironments,
	interpolateEnvVars,
} from "./internal/environments";
export { $environmentsDirPath, $documentEnvironmentsDirPath } from "./internal/paths";
export type { EnvironmentColor, EnvironmentInfo, EnvironmentVars } from "./internal/environments";
export { getEnvironmentColor } from "./internal/environments";

// Export SecretsProxy
export {
	$secretsProxy,
	$selectedProfile,
	$secretsProfileOverride,
	$setSecretsProfileOverride,
	$selectedSecretsWorkspace,
	$setSelectedSecretsWorkspace,
	$allWorkspaceSecrets,
	$workspaceSecretNames,
	$workspaceSecretsByProfile,
	$workspaceSecretProfiles,
	$workspaceSecretsLoadStatus,
	$createSecret,
	$deleteSecret,
	$variablesPopoverOpen,
	SecretsProxyError,
} from "./internal/secretsproxy";
export type {
	CreateSecretInput,
	DeleteSecretInput,
	ListSecretsResponse,
	SecretResponse,
	SecretsProxyAPI,
	VariablesPopoverRequest,
	VariablesPopoverTab,
	WorkspaceSecretsLoadStatus,
	WorkspaceSecretsByProfileState,
	WorkspaceSecretsState,
} from "./internal/secretsproxy";

// Export Terminal
export {
	generateTerminalId,
	$spawnTerminal,
	$terminalState,
	$orderedTerminalInstanceKeys,
	$activeTerminalInstanceKey,
	$defaultShell,
	getDefaultShell,
	type ShellInfo,
	// Terminal instance atoms (UI layer)
	$terminalInstances,
	$terminalInstance,
	$initializeTerminal,
	$connectTerminalPty,
	$setTerminalHeight,
	$destroyTerminalInstance,
	$destroyTerminalInstancesForDocument,
	$updateTerminalTheme,
	$restartTerminal,
	keyToString,
	stringToKey,
	terminalThemes,
	// Command availability
	$commandAvailability,
	$selectedTerminalCommand,
	$queuedTerminalPrompt,
} from "./internal/terminal";
export type {
	TerminalHandle,
	TerminalSpawnOptions,
	TerminalState,
	TerminalStatus,
	ScriptOutput,
	// Terminal instance types
	TerminalTheme,
	TerminalInstanceKey,
	TerminalInstance,
	InitializeTerminalParams,
	RestartTerminalParams,
	// Command types
	CommandInfo,
	CommandAvailability,
	TerminalCommandType,
} from "./internal/terminal";

// Export Product Analytics
export {
	$trackDocumentCreated,
	$trackDocumentCreationFailed,
	$trackDocumentOpened,
	$trackDocumentPublished,
	$trackDocumentShared,
	$trackTerminalDiscovered,
} from "./internal/analytics";
export type {
	DocumentCreationMeta,
	DocumentCreationSource,
	DocumentOpenMeta,
	DocumentPublishMeta,
	DocumentShareMeta,
} from "./internal/analytics";

// Export Atom Tracing
export {
	enableWriteTracking,
	watchAtom,
	watchMetadataState,
	unwatchMetadataState,
	unwatchAllMetadataStates,
} from "./internal/tracing";
export type { WatchAtomOptions, Unwatch, AtomTransitionEvent } from "./internal/tracing";

// Runtime Error Log
export { logCodeCellError, logRequestPageError } from "./internal/runtime-error-log";

// Diagnostics Snapshots
export {
	clearDocumentSnapshots,
	removeCellFromSnapshot,
	writeCodeCellSnapshot,
	writeRequestPageSnapshot,
} from "./internal/diagnostics-snapshot";
